import React from 'react';
import { Box, Container, Heading, Text, Link, VStack } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './layout/Header';
import Footer from './layout/Footer';
import TopoBackdrop from './core/TopoBackdrop';

const NotFound = () => {
  return (
    <Box position="relative" minH="100vh" overflow="hidden">
      <Helmet>
        <title>Page not found | GPX to KML Converter</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <TopoBackdrop fade />
      <Box position="relative" zIndex={1}>
        <Header />
        <Container maxW="920px" py={{ base: 6, md: 10 }}>
          <VStack spacing={6} align="stretch" data-testid="not-found-panel">
            <Heading as="h1" size="2xl" mt={8}>Page not found.</Heading>
            <Text fontSize="lg">
              The page you were looking for doesn't exist or may have been moved.
            </Text>
            <Link
              as={RouterLink}
              to="/"
              color="brand.primary"
              fontFamily="mono"
              fontSize="sm"
              letterSpacing="0.05em"
              textTransform="uppercase"
              alignSelf="flex-start"
            >
              &larr; Back to Home
            </Link>
          </VStack>
        </Container>
        <Footer />
      </Box>
    </Box>
  );
};

export default NotFound;
